import TransfersPage, { getDefaultPageData } from "components/pages/TransfersPage";
import { BCMSDefaultModel, BCMSStateManagerCRUD, BCMSRecord, useBCMSContext, useModel } from "bcms-react";
import Classes, { User, UserAccount } from "model";
import { useEffect, useState } from "react";

/**
 * @name CaptureMakeATransferMain
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Transfer Templates" (abi22).
 */
export default function CaptureMakeATransferMain(props) {
    const context = useBCMSContext();
    const model = useModel();
    BCMSRecord.globalControllerFor(Classes, context);
    const [ updateComp, setUpdateComp ] = useState(false);
    
    useEffect(() => {
        let user = model.user;
        const defaultUserAccount = BCMSDefaultModel.userAccount();
        
        user = { 
            ...user, 
            first: defaultUserAccount.first, 
            last: defaultUserAccount.last, 
            initials: defaultUserAccount.initials,
            allowTransferOnlyTemplates: "true"
        };

        BCMSRecord.batch([
            User.update(user)
        ], context, Classes);

        setUpdateComp(true);
    });
    
    return <TransfersPage  />;
}